import { ActionDescriptor } from '../common/commonTypes';
import DivideAttributeForm from './DivideAttributeForm';

const divideAttribute: ActionDescriptor = {
	FormComponent: DivideAttributeForm,
	actionTitle: 'Divide',
};

export default divideAttribute;
